import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'gnos-tooltip'
import cx from 'classnames'

import './style.scss'

export default class PaymentIndex extends Component {
    static propTypes = {
        clickHandler: PropTypes.func,
        clickIdentifier: PropTypes.string.isRequired,
        data: PropTypes.object,
        headerMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        identifier: PropTypes.string.isRequired,
        isLight: PropTypes.bool,
        naDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }

    handleOnClick = () => {
        const { clickHandler, clickIdentifier } = this.props

        if (clickHandler) {
            clickHandler(clickIdentifier)
        }
    }

    render() {
        const { headerMessage, identifier, data, isLight, tooltip, naDescription } = this.props

        const content = (
            <div className={cx('indicator-item', 'payment-index-section')}>
                <div className={'indicator-item-header'}>{headerMessage}</div>
                <div className={'payment-index-content'} onClick={this.handleOnClick}>
                    {isLight && data ? (
                        <div
                            className={cx('indicators-image', `light-pay-${data?.code}`, data?.riskIndicator && 'risk')}
                        />
                    ) : (
                        <div
                            className={cx('payment-code', data?.value)}
                            style={{ color: data?.color && !data?.inactive ? data.color : '#b3b3b3' }}
                        >
                            <span className={cx(data?.riskIndicator && 'risk')}>
                                {typeof data?.value === 'number' ? data.value : 'N/A'}
                            </span>
                        </div>
                    )}

                    <div className={'payment-description'}>{data?.description ? data.description : naDescription}</div>
                    <div className={cx('indicator-item-footer', 'magnifier')} />
                </div>
            </div>
        )

        return tooltip ? (
            <Tooltip id={`indicator_tooltip_${identifier}`} content={tooltip} key={`indicator_tooltip_${identifier}`}>
                {content}
            </Tooltip>
        ) : (
            content
        )
    }
}
